<template>
    <v-row justify="center">

        <v-dialog v-model="dialog" max-width="450" persistent>
            <v-card>
                <v-card-title class="text-h5">
                    Import transactions contis
                </v-card-title>

                <v-card-text>
                    This action will import all transactions from {{this.selectedPaymentFile[0]?JSON.stringify(this.selectedPaymentFile[0].sftpFile):null}} to the transactions table.
                    <br/><br/>
                    Note This action is ireversable and will set all transfered refrence numbers to as payed in the receipts table.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="green darken-1" text @click="dialog = false">
                        Cancel
                    </v-btn>

                    <v-btn color="green darken-1" text @click="importTransactions">
                        Accept
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-stepper v-model="e1">

            <v-stepper-header>
                <v-stepper-step :complete="e1 > 0" step="0">
                    Login
                </v-stepper-step>
                <v-stepper-step :complete="e1 > 1" step="1">
                    Select Campaigns
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" step="2">
                    Select Countries
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 3" step="3">
                    Generate File
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 4" step="4">
                    Preview and Download
                </v-stepper-step>

            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="0">
                    <form>
                        <v-text-field v-model="username" label="Username" required></v-text-field>
                        <v-text-field v-model="password" label="Password" required></v-text-field>
                        <v-btn color="primary" @click="login">Login and Continue</v-btn>
                    </form>
                </v-stepper-content>
                <v-stepper-content step="1">
                    <!-- card content: -->
                    <v-text-field v-model="endDate" placeholder="YYYY-MM-DD" :error-messages="this.dateError"
                        @blur="validateDate">
                    </v-text-field>
                    <v-btn @click='getCampaigns' :disabled="endDate.length < 1 || dateError.length > 1"
                        :loading="campaignsLoading">Get List
                    </v-btn>
                    <v-data-table v-if="pendingCampaigns.length > 0" :headers="pendigsHeaders" :items="pendingCampaigns"
                        disable-pagination v-model="selectedCampaigns" show-select item-key="campaignId"
                        class="elevation-1" hide-default-footer ></v-data-table>
                    <!-- <v-btn @click="generateList">Generate List</v-btn>
            <v-btn>Import to Contis</v-btn> -->
                    <!-- end card content -->
                    <v-btn color="primary" @click="getCountries" :loading="countriesLoading"
                        :disabled="selectedCampaigns.length < 1 ? true : false">
                        Continue
                    </v-btn>
                    <v-btn color="primary" @click="e1 = 5">
                        Skip to payment files selection
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-data-table v-if="!campaignsLoading" :headers="countriesHeaders" :items="pendingCountries"
                        disable-pagination v-model="selectedCountries" show-select item-key="country"
                        class="elevation-1" :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-arrow-collapse-left',
                            lastIcon: 'mdi-arrow-collapse-right',
                            prevIcon: 'mdi-minus',
                            nextIcon: 'mdi-plus'
                        }"></v-data-table>

                    <v-btn color="primary" @click="e1 = 3" :disabled="selectedCountries.length < 1 ? true : false">
                        Continue
                    </v-btn>

                    <v-btn text @click="reset">
                        Cancel
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="3">

                    <h3>Selected Campaigns</h3>
                    <v-divider></v-divider>

                    <div v-for="(campaign, idx) in selectedCampaigns" :key="`${idx}-campaigns`">
                        <div>
                            <div>{{ campaign.campaignId }}</div>
                        </div>
                    </div>
                    <v-divider></v-divider>

                    <h3>Selected Countries</h3>
                    <v-divider></v-divider>

                    <div v-for="(country, idx) in selectedCountries" :key="`${idx}-countries`">
                        <div>
                            <div>{{ country.country }}</div>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <h3>End Date</h3>
                    <v-divider></v-divider>
                    <div>
                        <div>{{ this.endDate }}</div>
                    </div>
                    <v-btn color="primary" @click="generateList" :loading="generateInprogress">Generate List</v-btn>

                    <v-btn text @click="reset">
                        Cancel
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <!-- card content: -->
                    <div>
                        <div>
                            {{ this.csvFile }}
                            <v-btn @click="getFileContent(csvFile)">Preview</v-btn>
                        </div>
                        <div>
                            {{ this.csvDesc }}
                            <v-btn @click="getFileContent(csvDesc)">Preview</v-btn>
                        </div>
                    </div>
                    <v-progress-linear v-model="previewProgress" color="amber" height="25"></v-progress-linear>
                    <v-textarea :value="content" cols=80 rows=32 wrap='off' class="text-area">
                    </v-textarea>
                    <!-- <v-btn color="primary" @click="e1 = 1">
                    Continue
                </v-btn> -->
                    <v-btn class="ml-5" @click="download(csvFile)">Download</v-btn>
                    <v-btn class="ml-5" @click="getFilesList">Continue</v-btn>
                    <v-btn class="ml-5" text @click="reset">
                        Cancel
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="5">
                    <v-data-table show-expand :headers="paymentFileHeaders" :items="paymentFiles"
                        v-model="selectedPaymentFile" show-select item-key="sftpFile" class="elevation-1"
                        :single-select="true" :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-arrow-collapse-left',
                            lastIcon: 'mdi-arrow-collapse-right',
                            prevIcon: 'mdi-minus',
                            nextIcon: 'mdi-plus'
                        }">

                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Generated Payment Files</v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length">
                                <div>
                                    Campaign ids: {{ item.campaignIds }}
                                </div>
                                <div>
                                    Countries: {{ item.countries }}
                                </div>
                            </td>
                        </template>

                    </v-data-table>
                    <v-btn color="warning" @click="importTransactionsDialog">
                        Import Transactions For Contis</v-btn>
                    <v-btn text @click="e1= 4">
                        Back
                    </v-btn>

                </v-stepper-content>
            </v-stepper-items>
            <v-stepper-content step="6">

            </v-stepper-content>

        </v-stepper>

    </v-row>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../store/helpers";
import moment from "moment";

export default {
    data() {
        return {
            token: null,
            dialog: false,
            username: '',
            password: '',
            csvFile: '',
            csvDesc: '',
            content: 'Click on the file you want to see',
            e1: 0,
            selectedCampaigns: [],
            selectedCountries: [],
            pendingCampaigns: [],
            pendingCountries: [],
            paymentFiles: [],
            selectedPaymentFile:[],
            generateInprogress: false,
            dateError: '',
            endDate: moment().subtract(5, "days").format("YYYY-MM-DD"),
            campaignsLoading: false,
            countriesLoading: false,
            pendigsHeaders: [
                {
                    text: 'campaignId',
                    value: 'campaignId'
                },
                {
                    text: 'receiptCount',
                    value: 'receiptCount'
                },
                {
                    text: 'total',
                    value: 'total'
                }],
            countriesHeaders: [
                {
                    text: 'country',
                    value: 'country'
                },
                {
                    text: 'receiptCount',
                    value: 'receiptCount'
                },
                {
                    text: 'total',
                    value: 'total'
                }],
            paymentFileHeaders: [{
                text: 'sftpFile',
                value: 'sftpFile'
            }, {
                text: 'preparedAt',
                value: 'preparedAt'
            }]
        }
    },
    computed: {
        ...mapGetters([
            "campaign",
            "userToken",
            "dashboardersList",
            "isAdmin",
            "campaignsList",
            "selectedDashboard",
            "userRoles",
            "previewProgress"
        ])
    },
    watch: {

    },
    mounted() {
    },
    methods: {
        validateDate(e) {
            const date = moment(e.target.value);
            if (!date.isValid()) this.dateError = 'Date value needs to be in YYYY-MM-DD format';
            else { this.dateError = ''; this.endDate = e.target.value }
        },
        login() {
            this.paymentsLogin({ username: this.username, password: this.password }).then(e => {
                if (e.response) {
                    this.e1 = 1
                    this.token = e.token
                }
            })
        },
        getFilesList(){
                    this.getPaymentFiles({token: this.token}).then(res => {
                        this.paymentFiles = res.paymentFiles;
                        this.e1 = 5
                        })

        },
        getCampaigns() {
            this.campaignsLoading = true
            this.getPendingCampaigns({ token: this.token, endDate: this.endDate }).then(r => {
                this.pendingCampaigns = r.campaigns
                this.campaignsLoading = false

            })
        },
        getCountries() {
            this.countriesLoading = true
            this.getPendingCountries({ token: this.token, endDate: this.endDate, campaigns: this.selectedCampaigns }).then(r => {
                this.pendingCountries = r.countries
                this.e1 = 2
                this.countriesLoading = false
            })
        },
        generateList() {
            this.generateInprogress = true
            this.generatePendingList({ token: this.token, endDate: this.endDate, campaigns: this.selectedCampaigns, countries: this.selectedCountries })
                .then(r => {
                    this.csvFile = r.path
                    this.csvDesc = r.descriptionPath
                    this.e1 = 4
                    this.generateInprogress = false
                })
        },
        getFileContent(file) {
            this.getCsvFileContent({ token: this.token, path: file })
                .then(r => {
                    this.content = r
                })
        },
        download(file){
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.content));
            element.setAttribute('download', file.split('https://js-payment-files.s3.eu-central-1.amazonaws.com/')[1]);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        importTransactionsDialog(){
            this.dialog = true
            
        },
        importTransactions(){
          this.s3ToTransactions({ path: this.selectedPaymentFile[0].sftpFile, token: this.token })
                .then(r => {
                    // this.e1 = 6
                    if(r.response){
                    this.dialog = false
                    return
                    }
                    alert('There was an error')

                }).catch(e=>{
                    alert('There was an error')
                })
        },

        reset() {
            this.e1 = 1
        },
        ...mapActions([
            "getPendingCampaigns",
            "getPendingCountries",
            "generatePendingList",
            "getCsvFileContent",
            "paymentsLogin",
            "getPaymentFiles",
            "s3ToTransactions"
        ])
    }
}

</script>
<style scoped>
.text-area {
    line-height: 2.0;
    font-size: 0.8em;
    font-family: system-ui;
}
</style>